// extracted by mini-css-extract-plugin
module.exports = {"videos":"Home_videos__3jD_h","content":"Home_content__OGPl9","approvalMode":"Home_approvalMode__M-wt2"};